import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IShiftComparativeReport } from '../../../utils/interfaces/shift-comparative-report';
import { IReportFilter } from '../../../utils/interfaces/report-filter';
import { IResponse } from '../../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class ShiftReportService {
  private readonly URI_API = environment.apiConfig.uri + 'ShiftComparativeReport';

  constructor(private readonly httpClient: HttpClient) {}

  getShiftComparativeReport(
    filter: IReportFilter
  ): Observable<IResponse<IShiftComparativeReport[]>> {
    return this.httpClient.post<IResponse<IShiftComparativeReport[]>>(
      `${this.URI_API}/comparative`,
      filter
    );
  }
}